var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoRenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.00026V6.34276C9.5 6.68026 9.905 6.84526 10.1375 6.60526L12.23 4.51276C12.38 4.36276 12.38 4.13026 12.23 3.98026L10.1375 1.88776C9.905 1.65526 9.5 1.82026 9.5 2.15776V3.50026C6.185 3.50026 3.5 6.18526 3.5 9.50026C3.5 10.2803 3.65 11.0303 3.9275 11.7128C4.13 12.2153 4.775 12.3503 5.1575 11.9678C5.36 11.7653 5.4425 11.4578 5.33 11.1878C5.1125 10.6703 5 10.0928 5 9.50026C5 7.01776 7.0175 5.00026 9.5 5.00026ZM13.8425 7.03276C13.64 7.23526 13.5575 7.55026 13.67 7.81276C13.88 8.33776 14 8.90776 14 9.50026C14 11.9828 11.9825 14.0003 9.5 14.0003V12.6578C9.5 12.3203 9.095 12.1553 8.8625 12.3953L6.77 14.4878C6.62 14.6378 6.62 14.8703 6.77 15.0203L8.8625 17.1128C9.095 17.3453 9.5 17.1803 9.5 16.8503V15.5003C12.815 15.5003 15.5 12.8153 15.5 9.50026C15.5 8.72026 15.35 7.97026 15.0725 7.28776C14.87 6.78526 14.225 6.65026 13.8425 7.03276Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoRenew);
export default __webpack_public_path__ + "static/media/Auto-Renew.8ea12938f71c4c82002164bc85066125.svg";
export { ForwardRef as ReactComponent };